<template>
    <div class="fullscreen-center">
        <p class="font-weight-bold">Processing Order</p>
        <i class="fas fa-sync-alt fa-spin fa-2x mt-3"></i>
        <!-- REMOVE LINK BEFORE LAUNCH -->
        <router-link :to="{ name: 'home' }">
            <p class="mt-4">&copy; aNew<span class="text-dark-green">Item</span></p>
        </router-link>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    name: "ProcessingOrder",
    props: {
        paymentId: {
            type: String,
            required: false
        },
        paymentMethod: {
            type: String,
            required: false
        },
        orderNumber: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            payObj: null,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['fetchPaymentLink', 'completePayment']),
        runBankTransferFxn() {
            // ensure script doesn't proceed without the order number and bank transfer as method
            if(this.paymentMethod !== process.env.VUE_APP_ANI_PAY_MTD_BNK_TRS) return

            // remove all data stored in local storage and redirect to confirmation page - Bank transfer payment methods
            if(this.orderNumber){
                // empty local storage because this is the end of order process via bank transfer
                this.emptyLocalStoragesFxn()

                // redirect shopper to see the order confirmation number on its page
                setTimeout(() => {
                    this.$router.push({
                        name: 'order-confirmation',
                        params: {
                            orderNumber: this.orderNumber
                        }
                    }).catch((e) => {})
                }, 2000) // simulate ajax-call ;-)
            }
        },
        runFetchPayment() {
            // before proceeding, check if it was a bank transfer payment method
            this.runBankTransferFxn()

            // proceed with completing online payment method
            let paymentObj = {
                paymentId: this.paymentId
            }
            this.fetchPaymentLink(paymentObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    // only redirect to payment gateway if a payLink is available - Online payment payment methods
                    if(data.result && data.result.payLink){
                        // proceed to send the shopper to payment gateway pay link
                        setTimeout(() => {
                            window.location = data.result.payLink
                        }, 1000) // simulate ajax-call ;-)
                    }
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = 'Unable to fetch payment resources at this time! Try again'
            })
        },
        runCompletePayment(transactionId) {
            // very important! It stops the page from going into loop!
            if(!transactionId) return
            let paymentObj = {
                transactionId,
                paymentId: this.paymentId,
            }
            this.completePayment(paymentObj) 
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    this.payObj = data.result
                    
                    // convert to string and store as redundancy measure
                    localStorage.setItem('_p89rc49s', JSON.stringify(this.payObj))

                    // proceed to delete all data stored in local storage to make the order possible
                    if(data && data.result){
                        this.emptyLocalStoragesFxn()
                    }

                    // redirect shopper to see the order confirmation number on its page
                    this.$router.push({
                        name: 'order-confirmation',
                        params: {
                            orderNumber: data.result.orderNumber
                        }
                    }).catch((e) => {})
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        },
        emptyLocalStoragesFxn() {
            localStorage.removeItem('_p89rc49s')
            localStorage.removeItem('ani_items_atc')
            localStorage.removeItem('ani_items_shp')
        }
    },
    mounted() {
        this.payObj = null

        // very important to ensure this page don't go into loop cycle
        if(!this.$route.query.status){
            // first, check to re-fetch the receipt from local storage if any
            if(localStorage.getItem('_p89rc49s')){
                this.payObj = JSON.parse(localStorage.getItem('_p89rc49s'))
                // wipe off the stored payment receipt if a new payment link is launched
                if(this.paymentId !== this.payObj.paymentId){
                    this.runFetchPayment()
                }
            } 
            // second, proceed to fetch payment details fresh from api db
            else {
                this.runFetchPayment()
            }
        }

        // proceed to verify the new payment 
        if(this.$route.query.status && this.$route.query.status === "successful"){
            this.runCompletePayment(this.$route.query.transaction_id)
        }

        // send shopper see the unable to complete payment error page
        if(this.$route.query.status && this.$route.query.status !== "successful"){
            this.$router.push({
                name: 'order-confirmation'
            }).catch((e) => {})
        }
    },
    created() {
        this.$emit('update:layout', LayoutAuth);
    }
}
</script>